export enum AcceptanceType {
  ENTRY,
  MODIFICATION,
  CANCEL,
  EXPIRY,
  PAUSE,
  RESUME,
}

export namespace AcceptanceType {
  let elements = [
    AcceptanceType.ENTRY,
    AcceptanceType.MODIFICATION,
    AcceptanceType.CANCEL,
    AcceptanceType.EXPIRY,
    AcceptanceType.PAUSE,
    AcceptanceType.RESUME,
  ];
  let alias = "com.bcdfx.api.servicerequest.trading.AcceptanceType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
